module.exports = __webpack_public_path__ + "img/deng_7fbacbbf7.png";